module.exports = __webpack_public_path__ + "img/stormwat.8eaec247.png";